import React, { useState } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Title, Thumbnail, Files } from 'root/admin/components';
import store from 'root/admin/store';
import { Form, Field, Button, Input, Loader, Row, FileInput, RelationSelect } from '@smartplatform/ui';
import { Editor } from '../../components';

import './style.scss';

@withRouter @observer
export default class CouncilSessionEdit extends React.Component {

	@observable record = null;
	@observable error = null;
	@observable search = '';
	@observable isLoading = true;
	@observable videos = [''];
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		if (this.id) {
			try {
				this.record = await store.model.CouncilSession.findById(this.id, {
					include: ['meeting'],
				});
				this.videos = this.record.videos;
			}
			catch (e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.CouncilSession();
			this.record.publishAt = new Date();
		}
		
		this.isLoading = false;
	};
	
	onMeetingChange = meeting => {
		if (!meeting) return;
		if (!this.record.name) this.record.name = meeting.name;
		console.log('started', meeting.startedAt);
		this.record.date = (new Date(meeting.startedAt * 1000)).toISOString();
	};
	
	addVideo = () => {
		this.videos.push('');
	};
	
	beforeSave = record => {
		const videos = this.videos.filter(url => !!this.getYoutubeId(url));
		console.log('beforeSave', record, videos);
		record.videos = videos;
	};
	
	getYoutubeId = url => {
		let youtubeId = null;
		if (url) {
			let match = url.match(/^https:\/\/youtu\.be\/(.+)$/);
			if (match && match.length > 1) youtubeId = match[1];
			if (!youtubeId) {
				let match = url.match(/^https:\/\/www.youtube.com\/watch\?v=([\w\d]+)/);
				if (match && match.length > 1) youtubeId = match[1];
			}
		}
		return youtubeId;
	};
	
	onVideoUrlChange = (e, i) => {
		this.videos[i] = e.target.value;
		console.log('>', this.videos);
	};
	
	deleteVideo = i => this.videos.splice(i, 1);
	
	onSearch = (str) => {
		console.log('onSearch', str);
		this.search = str;
	};
	
	render() {
		if (this.isLoading) return '...';
		
		const where = { statusId: { neq: 3 }};
		if (this.search) where.name = { like: `%${this.search}%` };
		const filter = {
			where,
			order: 'id desc',
		};
		
		return (
			<div>
				<Title record={this.record} name="Публикация" />
				<Form record={this.record} beforeSave={this.beforeSave} rootPath="/admin">
					<Field property="name" label="Название" />
					<Field relation="meeting" label="Заседание (epz.iltumen.ru)">
						<RelationSelect
							property="name"
							filter={filter}
							onChange={this.onMeetingChange}
							onSearch={this.onSearch}
						/>
					</Field>
					<Field property="date" label="Дата заседания"/>
					<Field property="text" label="Текст"><Editor /></Field>
					
					<Field property="newsletter" label="Бюллетень"><FileInput /></Field>
					<Field property="protocol" label="Протокол"><FileInput /></Field>
					<Field property="transcript" label="Стенограмма"><FileInput /></Field>
					<Field property="transcript2" label="Стенограмма 2й день"><FileInput /></Field>
					
					<Field label="Фоторепортаж" relation="gallery" property="name"/>
					<Thumbnail record={this.record} label="Миниатюра" />
					
					{this.videos.map((url, i) =>
						<div key={i} className="row">
							<div className="col-lg-8 col-ms-8 col-sm-8 col-12 form-field">
								<label>Видео URL (формат: <code>https://youtu.be/lI7St5pLXyw</code> или <code>https://www.youtube.com/watch?v=lI7St5pLXyw</code>)</label>
								<input type="text" value={url} onChange={e => this.onVideoUrlChange(e, i)} />
							</div>
							<div className="col-lg-3 col-ms-3 col-sm-3 col-11 form-field">
								<label>Youtube ID (если пустое - значит URL видео некорректное):</label>
								<input type="text" value={this.getYoutubeId(url) || '-'} disabled />
							</div>
							<div className="col-lg-1 col-ms-1 col-sm-1 col-1 form-field">
								<label>&nbsp;</label>
								<Button onClick={e => this.deleteVideo(i)}>Удалить</Button>
							</div>
						</div>
					)}
					<div className="form-field">
						<Button onClick={this.addVideo} className="btn-primary">Добавить видео</Button>
					</div>
					<Field property="publish" label="Опубликовать"/>
				</Form>
			</div>
		);
	}
	
}

